export const departmentDropdownList = [
  { label: 'PO본부', value: 'DEP1000001' },
  { label: 'PD본부', value: 'DEP1000002' },
  { label: 'LRD본부', value: 'DEP1000003' },
  { label: '기술본부', value: 'DEP1000004' },
  { label: '컨설팅본부', value: 'DEP1000005' },
  { label: '신사업개발본부', value: 'DEP1000006' },
  { label: '재무전략실', value: 'DEP1000007' },
  { label: '경영지원실', value: 'DEP1000008' },
  { label: '마케팅팀', value: 'DEP1000009' },
  { label: '전략실', value: 'DEP1000010' },
  { label: '법무감사실', value: 'DEP1000011' },
  { label: '전사고문', value: 'DEP1000012' },
  { label: '마크애니 체인버스', value: 'DEP1000013' },
];
